import { cx } from '@emotion/css';
import type { FC } from 'react';

import { getBackgroundClassName } from '../../../utils';
import {
  footerBarContainerCss,
  footerBarContainerOffsetCss,
  footerBarCss,
  footerBarFullWidthCss,
  wrapperCss,
} from './styles';
import type { FooterBarProps } from './types';

export const FooterBar: FC<FooterBarProps> = ({
  children,
  backgroundColor,
  hasSideNav,
  fullWidth,
  footerBarClassName,
  footerBarWrapperClassName,
}) => {
  return (
    <div
      data-testid="footer-bar"
      className={cx(getBackgroundClassName(backgroundColor), wrapperCss, footerBarWrapperClassName)}
    >
      <div className={cx(footerBarContainerCss, { [footerBarContainerOffsetCss]: hasSideNav })}>
        <div
          className={cx(footerBarCss, { [footerBarFullWidthCss]: fullWidth }, footerBarClassName)}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
